/**
 * Reusable card styles for workflow selection cards
 */

import { COLORS } from "./theme";

export const workflowCardStyles = {
    base: {
        padding: 28,
        height: "100%",
        cursor: "pointer",
        border: `2px solid ${COLORS.borderGray}`,
        borderRadius: 12,
        transition: "all 0.3s ease",
        backgroundColor: COLORS.white,
    },

    iconContainer: {
        width: 48,
        height: 48,
        borderRadius: 10,
        backgroundColor: COLORS.bgLight,
        display: "flex" as const,
        alignItems: "center" as const,
        justifyContent: "center" as const,
    },

    icon: {
        color: COLORS.iconGray,
        fontSize: 28,
    },

    titleContainer: {
        display: "flex" as const,
        alignItems: "center" as const,
        gap: 12,
        marginBottom: 16,
    },

    title: {
        color: COLORS.textDark,
        fontWeight: 600,
        fontSize: "18px",
    },

    description: {
        color: COLORS.textSecondary,
        fontSize: "14px",
        lineHeight: 1.6,
    },
};

export const workflowCardHoverHandlers = {
    onMouseEnter: (e: React.MouseEvent<HTMLDivElement>) => {
        e.currentTarget.style.border = `2px solid ${COLORS.textDark}`;
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.12)";
    },

    onMouseLeave: (e: React.MouseEvent<HTMLDivElement>) => {
        e.currentTarget.style.border = `2px solid ${COLORS.borderGray}`;
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
    },
};

export const workflowSelectionHeaderStyles = {
    container: {
        textAlign: "center" as const,
        marginBottom: 16,
    },

    title: {
        fontWeight: 600,
        color: COLORS.textDark,
        marginBottom: 8,
        fontSize: "28px",
        letterSpacing: "-0.5px",
    },

    subtitle: {
        color: COLORS.textSecondary,
        fontSize: "15px",
        maxWidth: 600,
        margin: "0 auto",
    },
};
